<template>
  <HTag :color="tagColor">
    {{ tag.label }}
  </HTag>
</template>

<script>
import { HTag } from '@/components/shared/atoms'

export default {
  name: 'CChannelTag',
  components: {
    HTag
  },
  props: {
    tag: {
      type: Object,
      required: true,
      validator: tag => !!tag?.label && !!tag?.type
    }
  },
  computed: {
    tagColor() {
      const COLORS_MAPPER = {
        ARCHIVED: 'gray',
        CHAT: 'magenta',
        FIRST_ACCESS: 'magenta'
      }

      return COLORS_MAPPER[this.tag.type] || 'violet'
    }
  }
}
</script>
